
import { usePaginatedQuery, useQuery as useConvexQuery } from "convex/react";
import { api } from "../../api";
import { useMemo } from "react";
import { useCurrentUser } from "@/hooks/useCurrentUser";

interface ScopeDevice {
  id: string;
  name: string;
  model?: string;
  serial_number?: string;
  status: "active" | "prepared" | "inactive";
}

interface ScopeLevel {
  id: string;
  name: string;
  description?: string;
  deviceCount: number;
}

export const useScopeDevices = () => {
  // Get current user role - handle unauthenticated case
  const { user, isAuthenticated } = useCurrentUser();
  const userRole = user?.roles?.[0]?._id;

  const devicesQuery = usePaginatedQuery(
    api.devices.list.all, 
    isAuthenticated ? {} : "skip",
    { initialNumItems: 100 }
  );

  const devices = useMemo(() => {
    if (!devicesQuery.results) return [];
    
    return devicesQuery.results.map((device: any): ScopeDevice => ({
      id: device._id,
      name: device.serial || `Device ${device.jssid || 'Unknown'}`,
      model: device.model,
      serial_number: device.serial,
      status: "active"
    }));
  }, [devicesQuery.results]);

  return {
    data: devices,
    isLoading: devicesQuery.isLoading,
    error: null
  };
};

export const useScopeLevels = () => {
  const levelsQuery = usePaginatedQuery(
    api.levels.list.all, 
    {},
    { initialNumItems: 100 }
  );

  const levels = useMemo(() => {
    if (!levelsQuery.results) return [];
    
    return levelsQuery.results.map((level: any): ScopeLevel => ({
      id: level._id,
      name: level.name,
      description: level.description,
      deviceCount: 0
    }));
  }, [levelsQuery.results]);

  return {
    data: levels,
    isLoading: levelsQuery.isLoading,
    error: null
  };
};
